// shadcn/ui Calendar component vendored (lite) implementation
import * as React from 'react'
import { addMonths, eachDayOfInterval, endOfMonth, format, getDay, isSameDay, isSameMonth, startOfMonth } from 'date-fns'

export function Calendar({ selected, onSelect, className, mode = 'single' as const }: { selected?: Date, onSelect?: (d: Date | undefined) => void, className?: string, mode?: 'single' }) {
  const [month, setMonth] = React.useState(startOfMonth(selected ?? new Date()))
  const start = startOfMonth(month)
  const end = endOfMonth(month)
  const days = eachDayOfInterval({ start, end })
  const offset = getDay(start)

  return (
    <div className={className}>
      <div className="flex items-center justify-between p-2">
        <button aria-label="Prev month" onClick={() => setMonth(m => addMonths(m, -1))}>{'<'}</button>
        <div className="text-sm font-medium">{format(month, 'LLLL yyyy')}</div>
        <button aria-label="Next month" onClick={() => setMonth(m => addMonths(m, 1))}>{'>'}</button>
      </div>
      <div className="grid grid-cols-7 gap-1 p-2 text-xs text-muted-foreground">
        {['Su','Mo','Tu','We','Th','Fr','Sa'].map(d => (<div key={d} className="text-center">{d}</div>))}
      </div>
      <div className="grid grid-cols-7 gap-1 p-2">
        {Array.from({ length: offset }).map((_, i) => (<div key={`e${i}`} />))}
        {days.map(d => (
          <button
            key={d.toISOString()}
            className={`rounded border p-2 text-sm ${isSameMonth(d, month) ? '' : 'opacity-40'} ${selected && isSameDay(d, selected) ? 'bg-primary text-primary-foreground' : ''}`}
            onClick={() => onSelect && onSelect(d)}
          >
            {format(d, 'd')}
          </button>
        ))}
      </div>
    </div>
  )
}

export default Calendar
